import * as React from 'react';
import { t } from 'i18next';

import * as ScanSurface from './scan-surface.svg';
import { ArStore, ArStoreState } from '../../stores/ArStore';
import { BaseComponent } from '../BaseComponent';
import { primaryColor, primaryColorLight } from '../../layout/BaseLayout';

interface ArHintState {
    show: boolean;
}

class ArHint extends BaseComponent<{}, ArHintState> {
    public componentWillMount(): void {
        this.addStoreListener(ArStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.show) {
            return null;
        }
        return (
            <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1300, pointerEvents: 'none'}}>
                <img src={ScanSurface} style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}/>
                <span
                    className="sidebar-bottom-margin"
                    style={{
                        position: 'absolute',
                        border: `1px solid ${primaryColor}`,
                        padding: 10,
                        backgroundColor: primaryColorLight,
                        bottom: 20,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        borderRadius: 4,
                        fontSize: 12,
                        maxWidth: '90vw',
                        textAlign: 'center'
                    }}
                >
                    {t('Please film the floor and move your device sideways.')}
                </span>
            </div>
        );
    }

    protected onChange = () => {
        const storeState: ArStoreState = ArStore.getState();
        this.setState({
            show: storeState.arDevice && storeState.started && !storeState.objectIsPlaced
        });
    };
}

export default ArHint;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ar/ArHint.tsx